module.exports = __webpack_public_path__ + "img/go-build-logo.14d6171f.jpg";